import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Globe } from 'lucide-react';

const LanguageSwitcher = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const langMatch = location.pathname.match(/^\/(en)(\/|$)/);
  const isEnglish = !!langMatch;

  const toggleLanguage = () => {
    if (isEnglish) {
      const newPath = location.pathname.replace(/^\/en/, '') || '/';
      navigate(newPath);
    } else {
      const suffix = location.pathname === '/' ? '' : location.pathname;
      navigate(`/en${suffix}`);
    }
  };

  return (
    <button
      onClick={toggleLanguage}
      className="header-btn header-btn-lang"
      title={isEnglish ? '切換至中文' : 'Switch to English'}
      aria-label={isEnglish ? '切換至中文' : 'Switch to English'}
    >
      <Globe size={16} />
      <span>{isEnglish ? '中文' : 'EN'}</span>
    </button>
  );
};

export default LanguageSwitcher;
